import { render, staticRenderFns } from "./full-review-modal.vue?vue&type=template&id=a6ca0d3a"
import script from "./full-review-modal.js?vue&type=script&lang=js&external"
export * from "./full-review-modal.js?vue&type=script&lang=js&external"
import style0 from "./full-review-modal.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports